<template>
  <el-container v-title data-title="卡片图" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>其它功能</el-breadcrumb-item>
                <el-breadcrumb-item>卡片图</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="detailCardPictureParam">查询</el-button>
                </el-form-item>
              </el-form>
              <el-form :inline="true" :model="cardPictureParam" class="demo-form-inline" >
                <el-row style="height: 620px">
                  <el-col :span="12" style="text-align: center; min-height:1px">
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :show-file-list="false"
                      :on-change="handleOnChangeForBackgroundPic"
                      :auto-upload="false">
                      <el-button size="small" type="success">上传背景图</el-button>
                    </el-upload>
                    <br>
                    <img style="max-width:100%; max-height:500px;" :src="cardPictureParam.backgroundPic" />
                  </el-col>
                  <el-col :span="12" style="text-align: center; min-height:1px; padding-left: 10px">
                    <el-row>
                      <el-form-item label="每页数量">
                        <el-select v-model="cardPictureParam.paramObject.qtyInPage">
                          <el-option label="5x2" value="5x2"></el-option>
                          <el-option label="4x3" value="4x3"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="照片左间距">
                          <el-input v-model="cardPictureParam.paramObject.headImage.marginLeft" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="照片上间距">
                          <el-input v-model="cardPictureParam.paramObject.headImage.marginTop" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="照片宽度">
                          <el-input v-model="cardPictureParam.paramObject.headImage.width" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="照片高度">
                          <el-input v-model="cardPictureParam.paramObject.headImage.height" maxlength="5" placeholder="照片高度"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="文字大小">
                          <el-input v-model="cardPictureParam.paramObject.font.size" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="文字颜色">
                          <el-input v-model="cardPictureParam.paramObject.font.color" maxlength="7" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="文字下划线">
                          <el-select v-model="cardPictureParam.paramObject.font.underline">
                            <el-option label="有" value="1"></el-option>
                            <el-option label="无" value="0"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="第一行类型">
                          <el-select v-model="cardPictureParam.paramObject.firstLine.type">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="姓名" value="realName"></el-option>
                            <el-option label="学号/工号" value="no"></el-option>
                            <el-option label="班级" value="className"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第一行左间距">
                          <el-input v-model="cardPictureParam.paramObject.firstLine.marginLeft" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第一行上间距">
                          <el-input v-model="cardPictureParam.paramObject.firstLine.marginTop" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="第二行类型">
                          <el-select v-model="cardPictureParam.paramObject.secondLine.type">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="姓名" value="realName"></el-option>
                            <el-option label="学号/工号" value="no"></el-option>
                            <el-option label="班级" value="className"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第二行左间距">
                          <el-input v-model="cardPictureParam.paramObject.secondLine.marginLeft" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第二行上间距">
                          <el-input v-model="cardPictureParam.paramObject.secondLine.marginTop" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="第三行类型">
                          <el-select v-model="cardPictureParam.paramObject.thirdLine.type">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="姓名" value="realName"></el-option>
                            <el-option label="学号/工号" value="no"></el-option>
                            <el-option label="班级" value="className"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第三行左间距">
                          <el-input v-model="cardPictureParam.paramObject.thirdLine.marginLeft" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="第三行上间距">
                          <el-input v-model="cardPictureParam.paramObject.thirdLine.marginTop" maxlength="5" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="24" style="text-align:center">
                    <!-- <el-form-item> -->
                      <el-button style="width:10%" type="primary" @click="confCardPicture">设置</el-button>
                    <!-- </el-form-item> -->
                  </el-col>
                </el-row>
              </el-form>
              <!-- <el-row></el-row> -->
              <el-divider></el-divider>
              <el-form>
                <el-form-item>
                  <el-upload
                    ref="file-list-upload"
                    class="upload-demo"
                    drag
                    :on-change="handleOnChange"
                    :action="uploadUrl"
                    :auto-upload="false"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
                    <div class="el-upload__text">上传图片，单个小于10MB，单次小于1000MB</div>
                  </el-upload>
                  <el-button style="margin-left: 10px;" :loading="loading" type="primary" @click="uploadFiles">合成</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      searchForm: {
        schoolId: ''
      },
      cardPictureParam: {
        'backgroundPic': '',
        'paramObject': {
          'qtyInPage': '',
          'headImage': {
            'marginLeft': 'a',
            'marginTop': 'b',
            'width': 'c',
            'height': 'd'
          },
          'font': {
            'size': '',
            'color': '',
            'underline': ''
          },
          'firstLine': {
            'type': '',
            'marginLeft': '',
            'marginTop': ''
          },
          'secondLine': {
            'type': '',
            'marginLeft': '',
            'marginTop': ''
          },
          'thirdLine': {
            'type': '',
            'marginLeft': '',
            'marginTop': ''
          }
        }
      },
      uploadUrl: this.GLOBAL.host + '/cardPicture/upload',
      fileList: [],
      loading: false
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.detailCardPictureParam()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    detailCardPictureParam () {
      if (this.searchForm.schoolId === '') return
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/cardPicture/detail',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.cardPictureParam = res.data.data
            console.log(_this.cardPictureParam)
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    confCardPicture () {
      if (this.searchForm.schoolId === '') return
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/cardPicture/config',
        _this.cardPictureParam
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.detailCardPictureParam()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    handleOnChangeForBackgroundPic (file, fileList) {
      // console.log(file)
      var reader = new FileReader()
      reader.readAsDataURL(file.raw)
      let _this = this
      reader.onload = function () {
        // console.log(reader.result)
        _this.cardPictureParam.backgroundPic = reader.result
      }
    },
    handleOnChange (file, fileList) {
      this.fileList = fileList
    },
    uploadFiles () {
      if (this.searchForm.schoolId === '' || this.fileList.length === 0) return
      let formData = new FormData()
      formData.append('schoolId', this.searchForm.schoolId)
      this.fileList.forEach(file => {
        formData.append('fileList', file.raw)
      })
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/cardPicture/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/zip'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
              _this.fileList = []
              _this.$refs['file-list-upload'].clearFiles()
            }
          }
          reader.readAsText(res.data)
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CardPicture.vue